import { Shark } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

import templateContent from "Templates/views/home.html";
import { refuelEditView } from "./refuelEditView";
import { mainNavComponent } from "../../components/mainNav/mainNavComponent";
import { vehiclePickUpView } from "./vehiclePickUpView";
import { vehicleReturnView } from "./vehicleReturnView";
import { vehicleManager } from "../managers/vehicleManager";
import { verifyVehicleView } from "./verifyVehicleView";

var homeView = Shark.createJaw("homeView");

homeView.templateContent = templateContent;
homeView.route = "home";

homeView.addMethod("beforeLoad", function () {
	if (Shark.get("vehicleList").length === 0) {
		vehicleManager.getList();
	}
	// //Al caricamento della pagina verifico se è stato conservato un utente precedentemente loggato e mi comporto di conseguenza.
	// //Vengono usati il metodo Shark.getInstance() per creare un'istanza di un Model ed il metodo Shark.set() per conservare le istanze nello store dell'applicazione.
	// if (localStorage.getItem("currDriver")) {
	// 	const loggedDriver = JSON.parse(localStorage.getItem("currDriver"));

	// 	if (loggedDriver.preserveLogin) {
	// 		Shark.set("currDriver", Shark.getInstance("Driver", loggedDriver));
	// 	}
	// }
	// else {
	// 	const lastUserEMail = localStorage.getItem("lastUserEMail") || "";

	// 	Shark.set("currDriver", Shark.getInstance("Driver", {eMail: lastUserEMail}));
	// }
});

homeView.addMethod("init", function () {
	Shark.set({
		vehicleList: Shark.get("vehicleList") || [],
		__showVerifyVehicleFunction: false
	});
    this.addComponents([mainNavComponent]);
});

homeView.addMethod("newRefuelBtn_clickHandler", function () {
    Shark.openPage(refuelEditView);
});

homeView.addMethod("vehiclePickUpBtn_clickHandler", function () {
    Shark.openPage(vehiclePickUpView);
});

homeView.addMethod("vehicleReturnBtn_clickHandler", function () {
    Shark.openPage(vehicleReturnView);
});

homeView.addMethod("verifyVehicleBtn_clickHandler", function () {
    Shark.openPage(verifyVehicleView);
});


Shark.registerView(homeView);

export { homeView };
